<template>
  <exo-help-dialog title="Reference trajectory for RAAN phasing">
    Two different choices can be made for the reference trajectory with respect
    to which the RAAN phasing is performed:
    <br />
    <br />
    <li>
      <b>Direct transfer:</b> the RAAN phasing is performed with respect to a
      spacecraft performing an orbital transfer between the initial and the
      final orbits. This case is of interest for two satellites injected at the
      same point that need to be deployed on two orbits having identical
      semi-major axis and inclination and whose ascending nodes are separated by
      the prescribed <katex-element expression="\Delta \Omega" />. See figure
      below.
    </li>
    <v-img
      contain
      :src="require('../../../assets/images/description-raan-phasing.png')"
      aspect-ratio="2"
    />
    <li>
      <b>Final orbit:</b> A target orbit, specified by its semi-major axis
      <katex-element expression="a_f" />, inclination
      <katex-element expression="i_f" /> and RAAN
      <katex-element expression="\Omega_f" />. This orbit is specified
      <b>on the same date as the initial orbit</b> (which is also equal to the
      simulation date). This case can be used to simulate a spacecraft that is
      launched via a rideshare solution and that needs to reach a target plane,
      where other spacecrafts might have already been deployed.
    </li>
    <v-img
      contain
      :src="require('../../../assets/images/tooltip-raan-phasing-rdv.png')"
      aspect-ratio="2"
    />
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipRaanPhasingReference'
}
</script>
